import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("刷新")
const _hoisted_2 = {
  style: {"margin-top":"20px"},
  "element-loading-text": "正在提交数据，请稍后"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 已被催办： ")
const _hoisted_5 = { class: "fc-d fw-700" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ，最近催办： ")
const _hoisted_7 = { class: "fc-d fw-700" }
const _hoisted_8 = {
  key: 1,
  style: {"margin-top":"10px"}
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 催办 ")

import { ref, unref, reactive } from 'vue';

import moment from 'moment';
import { ElMessage } from 'element-plus';

import { useAppStore } from '@/store/app'

/* Apis */
import { GetWorkTimeLineApi } from '@/apis/tasks/task.api';
import { AuditUrgeApi } from '../../../apis/contract/contract.api';



export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const contractId = ref<string>('')
const createUserId = ref<string>('')

const loading = ref<boolean>(false)

const state = reactive({
    urgeLoad: false,
})


const login = useAppStore().getLoginInfo;

const workList = ref()

/* 获取审批流程记录 */
const getWorkListData = (contractId: string) => {

    loading.value = true;
    GetWorkTimeLineApi(contractId).then(res => {
        if (!res.succeeded) {
            ElMessage.error(`流程数据读取失败，可能的原因是:${res.errors}`)
        }
        else {
            workList.value = res.data
        }
    }).finally(() => loading.value = false)
}

/* 催办 */
const onUrgeBtnClick = (workId: string) => {
    state.urgeLoad = true
    AuditUrgeApi(workId)
        .then(res => {
            if (!res.succeeded) {
                ElMessage.error(`操作失败，可能的原因是：${res.errors}`)
            }
            else {
                ElMessage.success(`催办操作成功`)
                if (contractId.value)
                    getWorkListData(unref(contractId))
            }
        })
        .finally(() => state.urgeLoad = false)
}

/* 刷新数据 */
const onRefreshBtnClick = () => {

    if (contractId.value)
        getWorkListData(unref(contractId))

}

/* 公开的方法 */
const methods: {

    setContractId: (ctId: string, createUserId: string) => void

} = {

    setContractId: (ctId: string, insEmpNo: string) => {

        contractId.value = ctId
        createUserId.value = insEmpNo

        getWorkListData(unref(contractId));
    }
}

expose({ methods })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: onRefreshBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      ((!workList.value ? 0 : workList.value.length) > 0)
        ? (_openBlock(), _createBlock(_component_el_timeline, {
            key: 0,
            style: {"min-height":"150px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  timestamp: item.node_name,
                  placement: "top",
                  hollow: true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", {
                      class: _normalizeClass(item.work_status_desc == '待处理' ? 'waittodo' : 'finish')
                    }, " 处理人：" + _toDisplayString(item.emp_name) + "(" + _toDisplayString(item.emp_no) + ")，动作：" + _toDisplayString(item.work_status_desc), 3),
                    _createElementVNode("p", null, "操作时间：" + _toDisplayString(item.action_date ? item.action_date : "--"), 1),
                    _createElementVNode("p", null, "审批意见：" + _toDisplayString(item.remark || '--'), 1),
                    (item.urge_total > 0 && item.work_status == '0')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                          _hoisted_4,
                          _createElementVNode("span", _hoisted_5, _toDisplayString(item.urge_total) + "次", 1),
                          _hoisted_6,
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(moment)(item.urge_time).format("YYYY-MM-DD HH:mm")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.work_status == '0' && createUserId.value == _unref(login).user_account && item.emp_no != _unref(login).user_account)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            loading: _unref(state).urgeLoad,
                            onClick: ($event: any) => (onUrgeBtnClick(item.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 2
                          }, 1032, ["loading", "onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["timestamp"]))
              }), 256))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "暂无审批记录"
          }))
    ])), [
      [_directive_loading, loading.value]
    ])
  ], 64))
}
}

})